module.exports = __webpack_public_path__ + "img/app-icon.157fb794.jpg";